/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Meta_TitleInputs */

const es_gift_meta_title = /** @type {(inputs: Gift_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjeta regalo náutica | Regala una aventura en barco | Zarpar`)
};

const gl_gift_meta_title = /** @type {(inputs: Gift_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarxeta agasallo náutica | Agasalla unha aventura en barco | Zarpar`)
};

const en_gift_meta_title = /** @type {(inputs: Gift_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nautical gift card | Give a boat adventure | Zarpar`)
};

/**
* | output |
* | --- |
* | "Nautical gift card \| Give a boat adventure \| Zarpar" |
*
* @param {Gift_Meta_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_meta_title = /** @type {((inputs?: Gift_Meta_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Meta_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_meta_title(inputs)
	if (locale === "en") return en_gift_meta_title(inputs)
	return es_gift_meta_title(inputs)
});